import { documentEntity } from '@api/api/document-entity';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

const QUERY_KEY_DOCUMENT_CONTENT = 'QUERY_KEY_DOCUMENT_CONTENT';

export const useDocumentContent = (documentId: string) =>
  useQuery({
    queryKey: [QUERY_KEY_DOCUMENT_CONTENT, documentId],
    queryFn: ({ signal }) =>
      wretchRequest<Blob | string>(
        documentEntity.getDocumentContent.path(documentId),
        {
          signal,
        }
      ),
    staleTime: getTimeTillEndOfDayMs(),
    enabled: !!documentId,
  });
